module.exports = __webpack_public_path__ + "img/asd.cb949367.webp";